@if(isOpen)
{
<div class="relative w-full rounded-xl border border-border shadow-md">
    <div class="p-6 flex flex-col gap-2">
        <p class="font-bold text-lg">
            @if(isEditing) { {{ 'admin.edit' | transloco }} }
            @else { {{ 'admin.new' | transloco }} }
            {{ 'admin.signals' | transloco }}</p>

        <!-- Name -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-labeled-input labelText="{{ 'admin.name' | transloco }}" [inputId]="'name'" [inputType]="'text'"
                [(inputValue)]="nameInput" [errorMessage]="nameInputError"
                placeholder="{{ 'admin.placeholders.eg_contract_ending_soon' | transloco }}"></app-labeled-input>
        </div>

        <!-- Formula -->
        <app-formula-input-box [(formula)]="formulaInput"></app-formula-input-box>
        <p class="text-sm text-neutral-500">{{ 'admin.combine_indicators_and_variables' | transloco}}</p>

        <!-- Description -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-textarea-input labelText="{{ 'admin.description' | transloco }}" [inputId]="'description'"
                [(textValue)]="descriptionInput" [errorMessage]="descriptionInputError"
                boxHeight="h-[150px]"></app-textarea-input>
        </div>

        <div class="flex gap-2 flex-wrap min-w-[300px]">
            <div class="h-[45px] w-[150px]">
                @if(isEditing)
                {
                <app-custom-button buttonText="{{ 'admin.update' | transloco }}" backgroundColor="bg-primary"
                    textColor="text-white" borderColor="border-primary" (buttonClick)="confirmButtonClick()"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>}
                @else {
                <app-custom-button buttonText="{{ 'admin.create' | transloco }}" backgroundColor="bg-primary"
                    textColor="text-white" borderColor="border-primary" (buttonClick)="confirmButtonClick()"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>}
            </div>

            <div class="h-[45px] w-[150px]">
                <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" backgroundColor="bg-[#FFFFFF]"
                    textColor="text-secondary" borderColor="border-secondary" hoverBackgroundColor="hover:bg-secondary"
                    hoverBorderColor="hover:border-secondary" (buttonClick)="closeView()"></app-custom-button>
            </div>
        </div>
    </div>
</div>
}